import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { NGXLogger } from 'ngx-logger';

import { BaseService } from '@shared/services/base.service';

import { Pagination } from '../../../shared/models';
import {
  StoreStockRecallListContent,
  StoreStockRecallRequestSearchCriteria
} from '../model/store-stock-recall-list.model';

@Injectable({
  providedIn: 'root'
})
export class StoreStockRecallListService extends BaseService {
  envService;
  headers: HttpHeaders;

  private readonly http = inject(HttpClient);
  protected readonly logger = inject(NGXLogger);

  constructor() {
    super();
    this.envService = this.env.services.stockStoreRecall;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  getStoreStockRecallList(criteria: StoreStockRecallRequestSearchCriteria) {
    const params = this.getParams(criteria);
    const url = this.getFullUrl(this.envService.list);

    return this.http.get<Pagination<StoreStockRecallListContent>>(url, {
      headers: this.headers,
      observe: 'body',
      params
    });
  }

  getStoreStockRecallView(docNo: string) {
    const url = this.getFullUrl(this.envService.view, { docNo });
    return this.http.get<any>(url, {
      headers: this.loaderHeaders(),
      observe: 'body'
    });
  }

  exportRecallTracking(docNo: string) {
    const url = this.getFullUrl(this.envService.recallTracking, { docNo });

    return this.http.get<any>(url, {
      headers: this.loaderHeaders(),
      observe: 'body',
      responseType: 'blob' as 'json'
    });
  }
}
